export const getCaptchaState = (state) => state.captcha;
export const isCaptchaLoadedState = (state) => state.captcha.loaded;
